import AndoraSVG from '../../../assets/contry-flag/AD.svg';
import AfganSVG from '../../../assets/contry-flag/AF.svg';
import AntiguaSVG from '../../../assets/contry-flag/AG.svg';
import AlbanSVG from '../../../assets/contry-flag/AL.svg';
import AngolaSVG from '../../../assets/contry-flag/AO.svg';
import ArgentinaSVG from '../../../assets/contry-flag/AR.svg';
import AlgeriaSVG from '../../../assets/contry-flag/DZ.svg';
export const dropDownData = [
  {
    label: 'Afghanisthan',
    value: 'Afghanisthan',
    image: AfganSVG,
  },
  {
    label: 'Albania',
    value: 'Albania',
    image: AlbanSVG,
  },
  {
    label: 'Algeria',
    value: 'Algeria',
    image: AlgeriaSVG,
  },
  {
    label: 'Andorra',
    value: 'Andorra',
    image: AndoraSVG,
  },
  {
    label: 'Angola',
    value: 'Angola',
    image: AngolaSVG,
  },
  {
    label: 'Antigua and Barbuda',
    value: 'Antigua and Barbuda',
    image: AntiguaSVG,
  },
  {
    label: 'Argentina',
    value: 'Argentina',
    image: ArgentinaSVG,
  },
];
